'use strict';

module.exports = function when(value, fn, defaultFn) {
  if (!value) {
    fn(this);
  } else {
    defaultFn(this);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/unless.js
// module id = 1289
// module chunks = 2